import { UseQueryResult, useQuery, UseMutationResult, useMutation } from '@tanstack/react-query'

import {
  MasterProvinceResponse,
  MasterDistrictResponse,
  MasterSubDistrictResponse,
  MasterPropertyResponse,
  GetMasterResponseZipCode,
  GetMasterRetailType,
} from 'services/interface'
import {
  getMasterProvice,
  getMasterDistrict,
  getMasterSubDistrict,
  getMasterProperty,
  getMasterZipcode,
  getMasterRetailType,
} from 'services/masterDataApi'

export const useGetMasterProvice = (): UseQueryResult<
  MasterProvinceResponse,
  Error
> => {
  return useQuery<MasterProvinceResponse, Error>({
    queryKey: ['province'],
    queryFn: () => getMasterProvice(),
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  })
}

export const useGetMasterDistrict = (
  provinceId: number
): UseQueryResult<MasterDistrictResponse, Error> => {
  return useQuery<MasterDistrictResponse, Error>({
    queryKey: ['province', provinceId],
    queryFn: () => getMasterDistrict(provinceId),
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  })
}

export const useGetMasterSubDistrict = (
  districtId: number
): UseQueryResult<MasterSubDistrictResponse, Error> => {
  return useQuery<MasterSubDistrictResponse, Error>({
    queryKey: ['district', districtId],
    queryFn: () => getMasterSubDistrict(districtId),
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  })
}

export const useMasterProperty = (): UseQueryResult<  
  MasterPropertyResponse,
  Error
> => {
  return useQuery<MasterPropertyResponse, Error>({
    queryKey: ['property'],
    queryFn: () => getMasterProperty(),
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  })
}

export const useGetZipcode = (
  zipCode: string
): UseQueryResult<GetMasterResponseZipCode, Error> => {
  return useQuery<GetMasterResponseZipCode, Error>({
    queryKey: ['zipCode', zipCode],
    queryFn: () => getMasterZipcode(zipCode),
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  })
}

export const useGetRetailType = (): UseQueryResult<GetMasterRetailType, Error> => {
  return useQuery<GetMasterRetailType, Error>({
    queryKey: ['retailType'],
    queryFn: () => getMasterRetailType(),
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  })
}
